import styled from "styled-components";
import { colors } from "../../../utils";

// Panel rendered inside a MUI Popover (which supplies the surface, elevation,
// click-away + focus/escape handling). Sizing mirrors the legacy
// NotificationDropDown but is responsive (never wider than the viewport).
export const Panel = styled.div`
  width: 380px;
  max-width: 92vw;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  /* QA-1014 part 5: no gray divider under the header either — the FB list reads
     as one continuous surface. */
  border-bottom: none;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const UnreadPill = styled.span`
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background-color: ${colors.PrimaryPurple};
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;

export const MarkAllButton = styled.button`
  background: none;
  border: none;
  padding: 4px 6px;
  font-size: 13px;
  font-weight: 600;
  color: ${colors.PrimaryPurple};
  cursor: pointer;
  border-radius: 6px;

  &:hover:not(:disabled) {
    background-color: ${colors.PrimaryPurple100};
  }
  &:disabled {
    color: #b9bdc7;
    cursor: default;
  }
  &:focus-visible {
    outline: 2px solid ${colors.PrimaryPurple};
    outline-offset: 1px;
  }
`;

// Scrollable feed body. Fixed max-height so the popover never runs off-screen;
// the list scrolls inside it.
export const FeedBody = styled.div`
  max-height: 52vh;
  overflow-y: auto;
`;

export const StateBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 10px;
  padding: 36px 20px;
`;

export const RetryButton = styled.button`
  border: 1px solid ${colors.PrimaryPurple};
  background: #ffffff;
  color: ${colors.PrimaryPurple};
  padding: 8px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover:not(:disabled) {
    background-color: ${colors.PrimaryPurple100};
  }
  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
  &:focus-visible {
    outline: 2px solid ${colors.PrimaryPurple};
    outline-offset: 1px;
  }
`;

export const PanelFooter = styled.div`
  /* QA-1014 part 5: no gray divider above the footer. */
  border-top: none;
  padding: 8px 16px 12px;
  display: flex;
  justify-content: center;
`;

// bell-panel-footer-placement-vs-deck: the deck puts "Mark all as read" + "View
// All" together in a footer bar pinned to the BOTTOM of the panel (matches the
// legacy NotificationDropDown's ButtonsContainer). QA-1014's FB-style rewrite
// moved both controls into the top header instead — this restores the deck's
// bottom-bar placement. A sibling of FeedBody (not inside its scroll region),
// so it stays pinned and visible instead of scrolling away with the rows.
export const PanelBottomBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-top: 1px solid #eef0f4;
`;

// Deck copy is "View All" (not "See all") — navigates to the routed
// /notifications full-list page, same corrected behavior as before.
export const ViewAllButton = styled.button`
  background: ${colors.PrimaryPurple};
  border: none;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 700;
  color: #ffffff;
  cursor: pointer;
  border-radius: 6px;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
  &:disabled {
    background: #d8d3f5;
    cursor: default;
  }
  &:focus-visible {
    outline: 2px solid ${colors.PrimaryPurple};
    outline-offset: 1px;
  }
`;

// QA-1014 part 9: "See previous notifications" at the BOTTOM. Drives infinite
// scroll — it appends the next page onto the running list and CONTINUES from the
// user's scroll position (the list is never remounted or reset to the top).
export const SeePreviousButton = styled.button`
  width: 100%;
  background: ${colors.PrimaryPurple50};
  border: none;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: 700;
  color: ${colors.PrimaryPurple};
  cursor: pointer;
  border-radius: 8px;

  &:hover:not(:disabled) {
    background-color: ${colors.PrimaryPurple100};
  }
  &:disabled {
    color: #b9bdc7;
    cursor: default;
  }
  &:focus-visible {
    outline: 2px solid ${colors.PrimaryPurple};
    outline-offset: 1px;
  }
`;
